const routes = [
  {
    index: true,
    label: 'Cyril Gadal',
    path: '/',
  },
  {
    label: 'Research',
    path: '/projects',
  },
  {
    label: 'CV',
    path: '/resume',
  },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Gallery',
    path: '/gallery',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
